/* ss-card-uso.js — la seconda foto, quella del prodotto gia' cucito.
   Desktop: compare al passaggio del mouse, ci pensa il CSS.
   Telefono: si scorre il dito sulla foto, in un verso o nell'altro.

   Due cautele. Gli ascoltatori sono passivi, quindi lo scorrimento verticale
   della pagina non viene mai bloccato: se il dito va piu' in verticale che in
   orizzontale, la card si tira fuori subito. E la card e' un collegamento,
   quindi dopo uno scorrimento il clic va fermato, altrimenti si apre la scheda.
   Un ascoltatore solo sul documento, cosi' vale anche per le card create dopo
   (Ci sta bene insieme). */
(function () {
  var SOGLIA = 40;       // px in orizzontale perche' conti come scorrimento
  var RAPPORTO = 1.4;    // quanto l'orizzontale deve battere il verticale

  var media = null, x0 = 0, y0 = 0, scambiato = false;

  function fotoDi(bersaglio) {
    var el = bersaglio && bersaglio.closest ? bersaglio.closest('.ss-card__media') : null;
    if (!el) return null;
    return el.querySelector('.ss-card__uso') ? el : null;  // solo dove la seconda foto esiste
  }

  document.addEventListener('touchstart', function (e) {
    scambiato = false;
    media = e.touches.length === 1 ? fotoDi(e.target) : null;
    if (!media) return;
    x0 = e.touches[0].clientX;
    y0 = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!media || scambiato || e.touches.length !== 1) return;
    var dx = e.touches[0].clientX - x0;
    var dy = e.touches[0].clientY - y0;
    if (Math.abs(dy) > Math.abs(dx)) { media = null; return; }   // sta scorrendo la pagina
    if (Math.abs(dx) < SOGLIA || Math.abs(dx) < Math.abs(dy) * RAPPORTO) return;
    var card = media.closest('.ss-card');
    if (card) { card.classList.toggle('is-uso'); scambiato = true; }
  }, { passive: true });

  document.addEventListener('touchend', function () { media = null; }, { passive: true });

  document.addEventListener('click', function (e) {
    if (!scambiato) return;
    scambiato = false;
    e.preventDefault();
    e.stopPropagation();
  }, true);
})();
